<h1 class="mb-5">Vessel Subgroups</h1>

<div class="row mb-3">
  <div class="col p-0">
    <input
      type="text"
      class="form-control"
      placeholder="Search by Vessel Type or Sub Type..."
      [(ngModel)]="searchTerm"
      (input)="filterOptions()"
    />
  </div>
  <div class="col p-0 text-right">
    <a routerLink="/homeAdmin/v2/vesselSubgroup/create" class="btn btn-primary"
      >Add Vessel Subgroup</a
    >
  </div>
</div>

<div *ngFor="let vessel of filteredVesselSubgroups" class="mb-4">
<div class="d-flex justify-content-between align-items-center mb-2">
  <h5>{{ vessel.vesselType }} - {{ vessel.subType }}</h5>
  <div>
    <a
      class="btn btn-sm btn-warning"
      [routerLink]="['/homeAdmin/v2/vesselSubgroup/edit', vessel.vesselType, vessel.subType]"
    >
      Edit
    </a>
    <button
      class="btn btn-sm btn-danger ml-2"
      (click)="deleteSubgroupGroup(vessel.subgroups)"
      style="margin-left: 8px;"
    >
      Delete
    </button>
  </div>
</div>

<div class="row mb-3">
  <div class="col-md-6">
    <label><strong>Lifetime (years):</strong></label>
    <input
      type="number"
      class="form-control"
      [value]="vessel.newLifeTime"
      readonly
    />
  </div>

  <div class="col-md-6">
    <label><strong>Conversion Factor (DWT to LWT):</strong></label>
    <input
      type="number"
      class="form-control"
      [value]="vessel.subgroups.length ? vessel.subgroups[0].conversionFactor : ''"
      readonly
    />
  </div>
</div>


  <table class="table table-striped">
    <thead>
      <tr>
        <th>SFI Code</th>
        <th>Description</th>
        <th>Emission factor</th>
        <th>Weight Distribution</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let subgroup of vessel.subgroups">
      <td>{{ subgroup.description === 'Assembly' ? '' : subgroup.sfiCode }}</td>
      <td>{{ subgroup.description }}</td>
      <td>{{(subgroup.coefficient | number:'1.2-2') }}</td>
      <td>{{ subgroup.description === 'Assembly' ? '' : (subgroup.weightDistribution + '%') }}</td>
        <td>
          
        </td>
      </tr>
    </tbody>
  </table>
</div>
